module.exports = __webpack_public_path__ + "static/media/IMG_1066.6b8ac90d.png";